export default "__VITE_ASSET__iscj3HmU__"